import ImageWrapper from './image-wrapper'
export default ImageWrapper
